<template>
  <div class="min-h-80 p-2 bg-gray-200 dark:bg-gray-900">
    <addModal @refresh="getAll" />
    <editModal @refresh="getAll" :detail="selected" />
    <div class="h-full p-2 bg-gray-50 dark:bg-gray-800 rounded shadow-sm">
      <div class="w-full">
        <LyrausTable
          :data="List"
          :columns="columns"
          :enablePagination="true"
          :isLoading="load"
          :batchOperations="true"
          :searchBar="true"
          :searchProp="search"
          @update-search-value="(val) => handleSearchValue(val)"
          :handleSearch="handleSearch"
          :pageCount="pageCount"
          :pageProp="currentPage"
          @update-current-page="handleCurrentPage"
          :totalCount="totalCount"
          :alternateRowBg="['white', 'gray-100']"
          :rightExtraSlot="true"
          :buttonsColumn="{ label: 'İşlem' }"
          :paginationButtonColor="'red-600'"
          :paginationHoverColor="'red-700'"
          :containerClass="'p-2 bg-gray-50 dark:bg-gray-800 rounded shadow-sm'"
          :innerThClass="'py-2 text-left text-xxs font-medium bg-red-300 tracking-wider border-gray-200'"
          :innerTdClass="'whitespace-nowrap text-xxs bg-red-200 py-2'"
        >
          <template v-slot:searchBar>
            <SearchInput :value="search" :isFull="true" @searcing="(val) => { handleSearchValue(val); handleSearch(); }" />
          </template>
          <template v-slot:batchOperations>
            <asyncBtn icon="fas fa-plus" text="Yeni İstasyon" class="w-36 btn" @click="() => $modal.show('add-fuel-station-modal')" />
          </template>
          <template v-slot:colButtons="{ item }">
            <div class="flex items-center justify-end space-x-2 px-2">
              <button class="mr-2" @click="showEditModal(item)">
                <i class="fas fa-pen text-gray-700"></i>
              </button>
              <button @click="deleteItem(item)">
                <i class="fas fa-trash text-gray-700"></i>
              </button>
            </div>
          </template>
        </LyrausTable>
      </div>
    </div>
  </div>
</template>

<script>
import asyncBtn from "@/components/general/asyncBtn.vue";
import SearchInput from "@/components/general/search-input.vue";
import axios from "axios";
import { fuel } from "@/networking/urlmanager";
import addModal from "./components/add.modal.vue";
import editModal from "./components/edit.modal.vue";

export default {
  name: "fuel-stations-module",
  components: { asyncBtn, addModal, editModal, SearchInput },
  data() {
    return {
      load: false,
      search: "",
      selected: { id: "" },
      List: [],
      totalCount: 0,
      pageCount: 1,
      currentPage: 0,
      columns: [
        { key: "name", label: "İstasyon Adı" },
        { key: "city", label: "Şehir" },
        { key: "district", label: "İlçe" },
        { key: "contactPhone", label: "Telefon" },
        { key: "fuelTypes", label: "Yakıt Türleri" },
        { key: "isContracted", label: "Anlaşmalı", formatter: (val) => val === 1 ? "Evet" : "Hayır" },
      ],
    };
  },
  methods: {
    showEditModal(item) {
      this.selected = item;
      setTimeout(() => { this.$modal.show("edit-fuel-station-modal"); }, 100);
    },
    handleSearch() {
      this.currentPage = 0;
      this.getAll();
    },
    handleCurrentPage(val) { this.currentPage = val; },
    handleSearchValue(val) {
      this.search = val;
      this.getAll(true);
    },
    getAll(isSearch = false) {
      if (isSearch) this.currentPage = 0;
      this.List = [];
      this.load = true;
      axios.get(fuel.stationGetAll + "?page=" + this.currentPage + "&search=" + this.search, {
        headers: { Authorization: "Bareer " + this.$store.state.userData.token },
      })
        .then((res) => {
          this.List = res.data.data.detail;
          this.totalCount = res.data.data.totalCount;
          this.pageCount = res.data.data.pageCount;
        })
        .catch((err) => { this.errorBox(err.response); })
        .finally(() => { this.load = false; });
    },
    deleteItem(item) {
      this.swalBox("warning", this.$t("general.warningTitle"), "İstasyonu silmek istediğinize emin misiniz?", true, this.$t("general.confirmText"), this.$t("general.rejectText"))
        .then((acc) => {
          if (acc.isConfirmed) {
            axios.post(fuel.stationDelete, { id: item.id }, {
              headers: { Authorization: "Bareer " + this.$store.state.userData.token },
            })
              .then(() => { this.swalBox("success", this.$t("general.successTitle"), "", false, this.$t("general.OkayTitle")); })
              .catch((err) => { this.errorBox(err.response); })
              .finally(() => { this.getAll(); });
          }
        });
    },
  },
  created() { this.getAll(); },
  watch: { currentPage() { this.getAll(); } },
};
</script>
